import { createSlice } from "@reduxjs/toolkit"
import { notification } from "antd"

// http client
import client from "../../lib/client"
import { billableAccountSearchUrl, billableAccountsScopedByClientUrl, billableAccountsUrl, billableAccountUrl, dynamicUrl, clientBillableAccountsCsvUrl, billableAccountNumberSearchUrl, billableAccountNotesUrl, billableAccountNoteUrl, billableAccountNoteByIdUrl, billableAccountNotesExportCsvUrl } from "../../lib/endpoints"
import { createFilterUrl } from "../../functions/objectFunctions/createFilterUrl"
import { createRansackParams } from "../../functions/objectFunctions/createRansackParams"
import { setAccountAlert } from "./billableAccountsSlice"

export const billableAccountNotesSlice = createSlice({
    name: "billableAccountNotes",
    initialState: {
        billableAccountNote: {},
        billableAccountNotes: [],
        total: 0,
        pagination: { current: 1, pageSize: 10 },
        loading: false,
        filters: {},
        sort: { column: "name", direction: "asc" },
    },
    reducers: {
        setBillableAccountNote: (state, action) => {
            state.billableAccountNote = action.payload
        },
        setBillableAccountNotes: (state, action) => {
            state.total = action.payload.total
            state.billableAccountNotes = action.payload.b_acc_notes
        },
        setPagination: (state, action) => {
            state.pagination = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setFilters: (state, action) => {
            state.filters = action.payload
        },
        setSort: (state, action) => {
            state.sort = action.payload
        },
        deleteBillableAccountNote: (state, action) => {
            state.billableAccountNotes = state.billableAccountNotes.filter((note) => note.id !== action.payload)
            state.total = state.total - 1
        },
    },
})

export const { setBillableAccountNote, setBillableAccountNotes, setPagination, setLoading, setFilters, setSort } = billableAccountNotesSlice.actions

export function fetchBillableAccountNote(clientId, billableAccountId, noteId) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))

        client.get(`${billableAccountNoteByIdUrl(clientId, billableAccountId, noteId)}`).then((response) => {
            dispatch(setBillableAccountNote(response.data))
            dispatch(setLoading(false))
        })
    }
}

export function fetchBillableAccountNotes(clientId, billableAccountId) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))

        client.get(`${billableAccountNotesUrl(clientId, billableAccountId)}`).then((response) => {
            // dispatch(setPagination(pagination))
            dispatch(setBillableAccountNotes(response.data))
            dispatch(setLoading(false))
        })
    }
}

export function submitBillableAccountNote(values, billableAccountNoteId, resetTable = false) {
    return async (dispatch, getState) => {
        if (billableAccountNoteId) {
            const response = await client.patch(billableAccountNoteUrl(billableAccountNoteId), { billable_account_note: values })
            // console.log(response)
            if(resetTable){
                dispatch(setBillableAccountNotes(response.data.message))
            }
            return response.data.message.notification
        } 
        else {
            console.log('here', billableAccountNoteId, values)
            const response = await client.post(billableAccountNoteUrl(billableAccountNoteId), { billable_account_note: values })
            return response.data
        }
    }
}

export function modifyAlert(newAlert) {
    return async (dispatch, getState) => {
        dispatch(setAccountAlert(newAlert))
    }
}

export function generateCsv(clientId, accountId) {
    return async (dispatch, getState) => {
        client.get(`${billableAccountNotesExportCsvUrl(clientId, accountId)}?connection_id=${getState().app.uid}`)
    }
}


export const selectBillableAccountNote = (state) => state.billableAccountNotes.billableAccountNote
export const selectBillableAccountNotes = (state) => state.billableAccountNotes.billableAccountNotes
export const selectTotal = (state) => state.billableAccountNotes.total
export const selectPagination = (state) => state.billableAccountNotes.pagination
export const selectLoading = (state) => state.billableAccountNotes.loading
export const selectFilters = (state) => state.billableAccountNotes.filters
export const selectSort = (state) => state.billableAccountNotes.sort

export default billableAccountNotesSlice.reducer
